import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map, filter, tap, take } from 'rxjs/operators';

import { LoginApiService } from './api/login-api.service';
import { TprecmUserProfile } from './api/tprecm-api.interface';

@Injectable()
export class UserService {
   userProfile = new BehaviorSubject<TprecmUserProfile>(undefined);

   isLoggedIn = false;
   isLoggedOut = false;
   constructor(private readonly loginApiService: LoginApiService) { }

   get UserProfile(): TprecmUserProfile {
      return this.userProfile.value;
   }

   public login() {
      return this.loginApiService.get()
         .pipe(
            filter(Boolean),
            map((val: any) => {
               this.userProfile.next(val);
               this.isLoggedIn = true;
            })
         );
   }

   public logout() {
      this.isLoggedIn = false;
      this.isLoggedOut = true;
   }

   public async getUserPermissions() {
      return this.userProfile
         .pipe(
            filter(Boolean),
            map((profile: TprecmUserProfile) => profile.permission || {}),
            take(1)
         ).toPromise();
   }

   public async getUserFieldPermissions() {
      return this.userProfile
         .pipe(
            filter(Boolean),
            map((profile: TprecmUserProfile) => profile.fieldPermission),
            take(1)
         ).toPromise();
   }
}
